import React, { useState } from 'react';
import { postUserPoints, convertPoints, trackSharePop } from '../../Utils/blogs';
import { GIFT_CARD_SVG, INCREASE_SVG, DECREASE_SVG } from '../staticTypes'
import Header from './Header';




const CovertPointes = (props) => {
	const { points } = props.data;
	const { onClick, launcherFlag, email, getReward, visitorId } = props;
	const [dots, setDots] = useState(0);
	const [redeem, setRedeem] = useState('Redeem');
	const [buttonDisabled, setButtonDisabled] = useState('');
	const [convert, setConvert] = useState('')
	const staticPoints = parseInt(points / 100);


	const getPoints = () => {
		const point = Number(dots) * 100;

		setDots(0);
		setRedeem(<div className="reward-loading"><span className="loading-all"></span></div>)

		convertPoints(email, point).then((res) => {
			if (res.code === 200) {
				const id = res.result;
				postUserPoints(email).then((res) => {
					setConvert('success');
					window.location.hash = '#/coupon-code?id='+id;
					setRedeem('Redeem');
					getReward(res.result);
				}).catch((err) => {
					console.log(err)
				})
				trackSharePop(email, visitorId, 'convert-point-success')
				
			}
		}).catch((err) => {
			console.log(err)
		})
	}
	const unClick = () => {
		return;
	}
	const changePoints = (e) => {
		
		if(Number(e.target.value) < staticPoints && Number(e.target.value) >= 0 ){
			setDots(e.target.value);		
		}else if(Number(e.target.value) < 0){
			setDots(0);
		}else if(Number(e.target.value) >= staticPoints){
			console.log(staticPoints)
			setDots(staticPoints);	
		}
	}
	const decreasePoints = () => {
		const newDots = dots;
		dots > 0 ? setDots(newDots - 1) : setDots(0);
	}
	const increasePoints = () => {
		const newDots = dots;
		dots < staticPoints ? setDots(newDots + 1) : setDots(staticPoints);
	}
	return (
		<div id="convert-points" className="convert-points">
			<Header points={points} onClick={onClick} launcherFlag={launcherFlag} link='/ways' />

			<div className="panel-container with-wantdo-footer">
				<div className="panel-card-container">
					<div className="card-list-container no-hover no-border">
						<div className="card-list-item-container ">
							<div className="card-list-item" aria-label="Order discount">
								<div className="card-list-item-content">
									{GIFT_CARD_SVG}
									<div className="list-item-text-wrapper">
										<div className="list-item-title">Order discount</div>
										<div className="list-item-subtitle text-muted">100 Points = $1</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="px-2 text-center">
						<div className="mb-5 px-3">
							<div className="mb-5 text-center">{dots * 100} Points for ${dots} off</div>
							<div className="reward-dots">
								<button className={`decrease-button click-points ${dots <= 0 ? 'opacity-0' : 'opacity-1'}`} onClick={decreasePoints}>
									{DECREASE_SVG}
								</button>
								<input className="text-input" type="number"
									max={staticPoints}
									value={dots}
									onChange={changePoints}
								/>
								<button className={`increase-point click-points ${dots >= staticPoints ? 'opacity-0' : 'opacity-1'}`} onClick={increasePoints}>
									{INCREASE_SVG}
								</button>
							</div>
						</div>
						<button
							className={`btn btn-primary ${dots >= 1 ? '' : 'disabled'}`}
							aria-label="Redeem reward"
							onClick={
								dots >= 1 ?
									getPoints
									:
									unClick
							}
						>{redeem}</button>
					
						
					</div>
				</div>
			</div>
		</div>
	);
}

export default CovertPointes;